@use '../style.scss' as *;
.container {
	display: none;
	position: absolute;
	bottom: 10px;
	right: 10px;
	z-index: 2;
	border-radius: 2px;
	border: 1px solid #d8e0e8;
	background: #fff;
	box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.15);
	padding: 10px;
	font-family: 'Ringside', sans-serif;
	font-size: 12px;
	line-height: 100%;
	width: 200px;
	@media only screen and (min-width: $mida-tall) {
		display: block;
	}
	.escala {
		display: flex;
		flex-flow: row nowrap;
		align-items: center;
		justify-content: space-between;
		gap: 10px;
		&:not(:first-child) {
			margin-top: 10px;
		}
	}
	.barra {
		display: block;
		width: 100%;
		height: 10px;
		margin-top: 5px;
	}
}
